import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";

import { OrdersPage, parseOrderSearch, type OrderFilters } from "@/features/orders";

function OrdersRoute(): JSX.Element {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <OrdersPage
      urlFilter={search}
      onUrlFilterChange={(next) => void navigate({ search: next, replace: true })}
    />
  );
}

export const Route = createFileRoute("/_authenticated/orders")({
  // Cast is safe under current URL semantics: each param appears at most once,
  // so TanStack's raw record values are strings (or absent) here.
  validateSearch: (raw: Record<string, unknown>): OrderFilters => parseOrderSearch(raw),
  component: OrdersRoute,
});
